// extracted by mini-css-extract-plugin
export default {"root":"Login_root__5fL+M","avatar":"Login_avatar__hIvQa","googleLoginButtonCard":"Login_googleLoginButtonCard__lJgxz","googleLoginButton":"Login_googleLoginButton__ruvwj"};